import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=fa1809ae&scoped=true"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"
import style0 from "./Box.vue?vue&type=style&index=0&id=fa1809ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1809ae",
  null
  
)

export default component.exports